import styled from '@emotion/styled';
import { bodyB, bodyM, subTitle2, title2 } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { DESKTOP } from '@/styles/themes';
export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 32px;
  * {
    margin: 0;
  }
`;

export const Topics = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
  ${DESKTOP} {
    gap: 80px;
  }
`;

export const Topic = styled.div`
  //display: flex;
  //flex-direction: column;
  white-space: pre-wrap;

  h3 {
    margin-bottom: 24px;
    ${subTitle2};
    color: ${vars.neutral[0]};
  }
  h4 {
    ${bodyB};
    color: ${vars.neutral[10]};
  }
  ul {
    ${bodyM};
    color: ${vars.neutral[40]};
    margin-left: 0;
    padding-left: 20px;
  }
  p {
    ${bodyM};
    color: ${vars.neutral[40]};
  }
  div {
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  div.gap_8 {
    gap: 8px;
  }
  ${DESKTOP} {
    h3 {
      margin-bottom: 32px;
      ${title2};
      color: ${vars.neutral[0]};
    }
    h4 {
      ${bodyB};
      color: ${vars.neutral[10]};
    }
    ul {
      ${bodyM};
      color: ${vars.neutral[40]};
      margin-left: 0;
      padding-left: 20px;
    }
    p {
      ${bodyM};
      color: ${vars.neutral[40]};
    }
    div {
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
    }
  }
`;

export const Divider = styled.div`
  min-height: 1px;
  width: 100%;
  background-color: ${vars.neutral[80]};
`;
